/**
 * The Instagram handle this browser last built a page from, so the landing's field
 * comes back filled. A convenience only: never attribution. A cookie, not localStorage,
 * so the server renders the field already filled instead of flashing its placeholder.
 * Written by `PrebuiltBuild` once the handle reads as a public account, hers or someone else's.
 */
export const LAST_INSTAGRAM_HANDLE = 'mm-last-instagram-handle';

const YEAR = 60 * 60 * 24 * 365;

export function writeLastInstagramHandle(handle: string): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LAST_INSTAGRAM_HANDLE}=${encodeURIComponent(handle)}; Max-Age=${YEAR}; Path=/; SameSite=Lax${secure}`;
}

/** Where it was kept until 2026-10-12. Read until the cookie fills the field, then cleared. */
export function legacyInstagramHandle(): string | null {
  try {
    return window.localStorage.getItem(LAST_INSTAGRAM_HANDLE);
  } catch {
    return null;
  }
}

export function clearLegacyInstagramHandle(): void {
  try {
    window.localStorage.removeItem(LAST_INSTAGRAM_HANDLE);
  } catch {
    // Storage unavailable: nothing was kept there.
  }
}
